export default __webpack_public_path__ + "static/media/marvel-captain.d2c7774d.jpg";